<flx-heading [align]="'center'" [size]="'medium'" weight="extra-light">{{ heading }}</flx-heading>
<flx-heading [align]="'center'" [size]="'small'" weight="extra-light">{{ subtitle }}</flx-heading>
<flx-glow-line [size]="'50vw'"></flx-glow-line>
<div class="key-value-list-container"><flx-key-value-list *ngIf="keyvaldata$" [data$]="keyvaldata$"></flx-key-value-list></div>
<flx-glow-line [size]="'50vw'"></flx-glow-line>
